<template>
  <v-col cols="12">
    <div>
      <naj-box
        :no-header="hideNajBox"
        :no-gutters="hideNajBox"
        :no-margin-bottom="hideNajBox"
        :title="locales.sectionTitle"
      >
        <v-row>
          <v-col cols="4">
            <naj-input
              :type-id="formFieldType.text"
              :label="locales.deedId"
              :value.sync="formModel.deedId"
              :disabled="isChecking || viewMode"
              validates="required|numeric"
              @input="deedIdChanged"
            ></naj-input>
          </v-col>

          <v-col cols="4">
            <naj-input
              :type-id="formFieldType.date"
              :label="locales.deedDate"
              :value.sync="formModel.deedDate"
              :disabled="isChecking || !formModel.deedId || viewMode"
              validates="required"
              @change="deedDateChanged"
            ></naj-input>
          </v-col>

          <v-col
            cols="4"
            align-self="center"
            class="text-right"
          >
            <naj-button
              v-if="isCheckButtonVisible"
              square
              :loading="isChecking"
              :disabled="isCheckButtonDisabled"
              @click="check"
            >
              {{ local.personInformation.check }}
            </naj-button>
          </v-col>
        </v-row>
      </naj-box>
    </div>

    <div>
      <naj-dynamic-form
        :form-model="formModel"
        :form-fields="form.fields"
        :view-mode="viewMode"
      ></naj-dynamic-form>
    </div>
  </v-col>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapGlobalActions } = createNamespacedHelpers('GlobalModule');

export default {
  name: 'BuildingInfo',
  props: {
    formModel: {
      type: Object,
      required: true,
    },
    rootFormModel: {
      type: Object,
      required: true,
    },
    hideNajBox: {
      type: Boolean,
      required: false,
    },
    viewMode: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      isRetrieved: false,
      isChecking: false,
      isManual: false,
      form: {
        'id': 39,
        'name': 'BuildingInfo',
        'label': 'بيانات العقار',
        'description': 'بيانات العقار',
        'isCustom': false,
        'customComponentName': null,
        'fields': [
          {
            'id': 41743,
            'typeId': 1,
            'name': 'buildingType',
            'label': 'وصف العقار',
            'columnSize': 4,
            'sortIndex': 1,
            'properties': '{"validations":{"required":"true"},"dataGridConfig":null,"dateConfig":{}}',
            'description': 'وصف العقار',
            'fields': [
            ],
          },
          {
            'id': 41744,
            'typeId': 1,
            'name': 'city',
            'label': 'المدينة',
            'columnSize': 4,
            'sortIndex': 2,
            'properties': '{"validations":{"required":"true"},"dataGridConfig":null,"dateConfig":{}}',
            'description': 'المدينة',
            'fields': [
            ],
          },
          {
            'id': 41745,
            'typeId': 1,
            'name': 'district',
            'label': 'الحي',
            'columnSize': 4,
            'sortIndex': 3,
            'properties': '{"validations":{"required":"true"},"dataGridConfig":null,"dateConfig":{}}',
            'description': 'الحي',
            'fields': [
            ],
          },
          {
            'id': 41746,
            'typeId': 11,
            'name': 'section',
            'label': 'بيانات صك ملكية العقار',
            'columnSize': null,
            'sortIndex': 4,
            'properties': '{"dataGridConfig":null,"dateConfig":{}}',
            'description': null,
            'fields': [
              {
                'id': 41748,
                'typeId': 1,
                'name': 'buildingOwnershipDeedSource',
                'label': 'مصدر الصـك',
                'columnSize': 4,
                'sortIndex': 1,
                'properties': '{"validations":{},"dataGridConfig":null,"dateConfig":{}}',
                'description': 'مصدر الصـك',
                'fields': [
                ],
              },
              {
                'id': 41749,
                'typeId': 1,
                'name': 'buildingOwnershipDeedNumber',
                'label': 'الرقم',
                'columnSize': 4,
                'sortIndex': 2,
                'properties': '{"validations":{"numeric":"true"},"dataGridConfig":null,"dateConfig":{}}',
                'description': 'الرقم',
                'fields': [
                ],
              },
              {
                'id': 41750,
                'typeId': 3,
                'name': 'buildingOwnershipDeedDate',
                'label': 'تاريخ',
                'columnSize': 4,
                'sortIndex': 3,
                'properties': '{"validations":{},"dataGridConfig":null,"dateConfig":{}}',
                'description': 'تاريخ',
                'fields': [
                ],
              },
              {
                'id': 41751,
                'typeId': 2,
                'name': 'buildingOwnershipDeedArea',
                'label': 'مساحه',
                'columnSize': 4,
                'sortIndex': 4,
                'properties': '{"validations":{},"dataGridConfig":null,"dateConfig":{}}',
                'description': 'مساحه',
                'fields': [
                ],
              },
              {
                'id': 41752,
                'typeId': 4,
                'name': 'buildingOwnershipDeedAreaUnit',
                'label': 'وحدة',
                'columnSize': 4,
                'sortIndex': 5,
                'properties': '{"validations":{"conditionalRequired":"!!obj.buildingOwnershipDeedArea"},"externalDataSource":{},"textName":"buildingOwnershipDeedAreaUnitName","pickListId":74,"disabledIf":"!obj.buildingOwnershipDeedArea","dataGridConfig":null,"dataSource":[{"key":1,"value":"متراً مربعاً","id":1,"name":"متراً مربعاً","statusId":1},{"key":2,"value":"أخرى","id":2,"name":"أخرى","statusId":1}],"dateConfig":{}}',
                'description': 'وحدة',
                'fields': [
                ],
              },
              {
                'id': 41753,
                'typeId': 1,
                'name': 'buildingOwnershipDeedAreaCustomUnit',
                'label': 'وحدة',
                'columnSize': 4,
                'sortIndex': 6,
                'properties': '{"validations":{"conditionalRequired":"obj.buildingOwnershipDeedAreaUnit==2"},"if":"obj.buildingOwnershipDeedAreaUnit==2","dataGridConfig":null,"dateConfig":{}}',
                'description': 'وحدة',
                'fields': [
                ],
              },
            ],
          },
          {
            'id': 41747,
            'typeId': 4,
            'name': 'sellingBuildingOptions',
            'label': 'خيارات بيع العقار',
            'columnSize': 6,
            'sortIndex': 5,
            'properties': '{"validations":{},"externalDataSource":{},"textName":"sellingBuildingOptionsName","pickListId":78,"dataGridConfig":null,"dataSource":[{"key":1,"value":"البيع فى المزاد العلنى","id":1,"name":"البيع فى المزاد العلنى","statusId":1},{"key":2,"value":"البيع للمدعى","id":2,"name":"البيع للمدعى","statusId":1}],"if":"obj.requestType&&obj.requestType.indexOf(3)!=-1","dateConfig":{}}',
            'description': 'خيارات بيع العقار',
            'fields': [
            ],
          },
        ],
      },
    };
  },
  computed: {
    locales() {
      return this.local.dynamicFormAdmin.customComponents.BuildingInfo;
    },
    isCheckButtonDisabled() {
      return (
        !this.formModel.deedId ||
        !this.formModel.deedDate ||
        this.isChecking
      );
    },
    isCheckButtonVisible() {
      return !this.isRetrieved || this.isChecking;
    },
    isFieldDisabled() {
      return this.isManual || this.isChecking;
    },
  },
  mounted() {
    if (this.formModel.objectKey) {
      this.isRetrieved = true;
    }
  },
  methods: {
    ...mapGlobalActions(['getRealEstateDeedInfo']),
    check() {
      this.isChecking = true;
      this.resetFlags();

      this.getRealEstateDeedInfo({
        deedId: this.formModel.deedId,
        deedDate: this.formModel.deedDate,
      })
        .then((res) => {
          if (res.data) {
            this.isRetrieved = true;
            const deedInfoResult = res.data.deedInfo;

            const mappedData = {
              objectKey: deedInfoResult.deedNumber,
              buildingType: deedInfoResult.deedMainRsType,
              city: deedInfoResult.deedCityName,
              district: deedInfoResult.neighborhood,
              buildingOwnershipDeedSource: deedInfoResult.deedCourtName,
              buildingOwnershipDeedNumber: deedInfoResult.deedNumber,
              buildingOwnershipDeedDate: this.formModel.deedDate,
              buildingOwnershipDeedArea: deedInfoResult.deedArea,
            };
            Object.keys(mappedData)
              .map((key) => {
                this.$set(this.formModel, key, mappedData[key]);
                return key;
              });
          }
        })
        .catch(() => {
          this.isManual = true;
          this.toaster.error(this.local.common.noData);
          this.clearFormData();
        })
        .finally(() => {
          this.isChecking = false;
        });
    },
    resetFlags() {
      this.isRetrieved = false;
      this.isManual = false;
    },
    deedDateChanged() {
      this.resetFlags();
    },
    deedIdChanged() {
      this.resetFlags();
      this.formModel.deedDate = null;
      this.clearFormData();
    },
    clearFormData() {
      const mappedData = {
        objectKey: null,
        buildingType: null,
        city: null,
        district: null,
        buildingOwnershipDeedSource: null,
        buildingOwnershipDeedNumber: null,
        buildingOwnershipDeedDate: null,
        buildingOwnershipDeedArea: null,
        buildingOwnershipDeedAreaUnit: null,
        buildingOwnershipDeedAreaCustomUnit: null,
      };
      Object.keys(mappedData)
        .map((key) => {
          this.$set(this.formModel, key, mappedData[key]);
          return key;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>